var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0164 8.09525C18.0164 11.1547 15.5634 13.6078 12.5019 13.6078C9.44135 13.6078 6.9873 11.1547 6.9873 8.09525C6.9873 5.03585 9.44135 2.58374 12.5019 2.58374C15.5634 2.58374 18.0164 5.03585 18.0164 8.09525Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 23.4171C7.98245 23.4171 4.16748 22.6827 4.16748 19.8493C4.16748 17.0149 8.00642 16.3066 12.5008 16.3066C17.0202 16.3066 20.8341 17.041 20.8341 19.8743C20.8341 22.7087 16.9952 23.4171 12.5008 23.4171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.ca33943ee6d24607b8863e9e53b71668.svg";
export { ForwardRef as ReactComponent };